import FTabMDP from "@/components/generic/FTabMDP";

export default class TaskFTabMDP extends FTabMDP {
  taskRoot: any;

  constructor({ taskRoot }: { taskRoot: any }) {
    super({
      myRefName: "taskFTabMDPRef",
    });
    this.taskRoot = taskRoot;


    this.addTab({
      tabName: "My Task",
      routerName: "PartnerAffiliate.TaskList.TaskAssignedToMe",
    }).addTab({
      tabName: "Pool",
      routerName: "PartnerAffiliate.TaskList.TaskPool",
    })
    .addTab({
      tabName: "Completed",
      routerName: "PartnerAffiliate.TaskList.TaskCompleted",
    })
    .addTab({
      tabName: "Suspended",
      routerName: "PartnerAffiliate.TaskList.TaskSuspended",
    })
  }

  getMyRef(): any {
    return this.taskRoot.$refs[this.myRefName];
  }
}
